var map = {
	"./like-plus-faq-70941": [
		40342,
		342
	],
	"./like-plus-faq-70941.js": [
		40342,
		342
	],
	"./like-plus-faq-70942": [
		10515,
		515
	],
	"./like-plus-faq-70942.js": [
		10515,
		515
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17140;
module.exports = webpackAsyncContext;